import React from 'react';
import { buildClassName } from '../../../utils';
import { NestedDropdownItem } from './NestedDropdownItem';
import { ChevronIcon } from './ChevronIcon';
import type { ExpandableMenuItem, MenuItem } from '../../../types';
import styles from '../DesktopNavigation.module.scss';

interface ExpandableDropdownItemProps {
  item: ExpandableMenuItem;
  isExpanded: boolean;
  onToggle: (itemId: string) => void;
  onItemClick: (item: MenuItem) => void;
}

export const ExpandableDropdownItem = ({ 
  item, 
  isExpanded, 
  onToggle, 
  onItemClick,
}: ExpandableDropdownItemProps) => {
  // Add test ID to match legacy header format: item.id + 'MenuDropdownOption'
  const testId = `${item.id}MenuDropdownOption`;
  
  return (
    <React.Fragment>
      <li>
        <button 
          onClick={() => onToggle(item.id)}
          className={styles.expandableHeader}
          data-testid={testId}
        >
          <span className={styles.expandableHeaderMain}>
            {item.leftSection}
            <span>{item.label}</span>
          </span>
          {/* Chevron icon that rotates based on expanded state */}
          <ChevronIcon 
            isExpanded={isExpanded}
            className={buildClassName(styles.expandIcon, isExpanded && styles.expandIconExpanded)}
          />
        </button>
      </li>
      {/* Render nested items only when expanded */}
      {isExpanded && item.items?.map(nestedItem => (
        <NestedDropdownItem 
          key={nestedItem.id} 
          item={nestedItem} 
          onItemClick={onItemClick} 
        />
      ))}
    </React.Fragment>
  );
}; 